<template>
    <div class="flex flex-col gap-2">
        <label class="font-semibold">{{ label }}</label>

        <select
            :value="modelValue"
            @change="handleChange"
            class="rounded bg-zinc-800 p-2 cursor-pointer">
            <option 
                v-for="option in options" 
                :key="option.value"
                :value="option.value"
            >
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'ItemDropdown',
    props: {
        label: String,
        modelValue: [String, Number],
        options: {
            type: Array,
            validator: (value) => {
                return value.every(option => 
                typeof option === 'object' && 
                    'value' in option && 
                    'label' in option
                )
            }
        },
    },
    setup(props, { emit }) {
        const handleChange = (event) => {
            const value = event.target.value
            
            // Convert to number if the current modelValue is a number
            const convertedValue = typeof props.modelValue === 'number' ? Number(value) : value
            emit('update:modelValue', convertedValue)
        }
        
        return {
            handleChange
        }
    },
    emits: ['update:modelValue'],
}
</script>